import { Component, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { selectAllFaqs } from '../../state/faq/faq.selector';
import { Faq } from '../../models/Faq';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { FaqState } from '../../state/faq/faq.reducer';
import { getAllFaqs } from '../../state/faq/faq.actions';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-faq',
  imports: [MatExpansionModule, CommonModule, MatIconModule, PageHeaderComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css',
})
export class FaqComponent implements OnInit {
  faqs$: Observable<Faq[]>;
  constructor(private faqStore: Store<{ faq: FaqState }>) {
    this.faqs$ = this.faqStore.select(selectAllFaqs);
  }

  ngOnInit() {
    this.faqStore.dispatch(getAllFaqs());
  }
}
